import React, {createContext, useState} from 'react';

const WayToViewContext = createContext({
  state: {viewList: 'grid-view'},
  actions: {
    setViewList: () => {},
  }
});

const WayToViewProvider = ({ children }) => {
  const [viewList, setViewList] = useState('grid-view');

  const value = {
    state: {viewList},
    actions: {setViewList}
  };

  return (
    <WayToViewContext.Provider value={value}>{children}</WayToViewContext.Provider>
  )
}

const {Consumer: WayToViewConsumer} = WayToViewContext;

export {WayToViewProvider, WayToViewConsumer};

export default WayToViewContext;